import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-20 md:pt-24 pb-28 md:pb-32 overflow-hidden" data-id="element-53">
      <div className="max-w-reading w-full mx-auto flex flex-col items-center text-center z-10" data-id="element-54">
        {/* Photo Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="w-32 h-32 md:w-40 md:h-40 rounded-full mb-10 overflow-hidden bg-gradient-to-br from-amber-light via-cream-dark to-sage-light shadow-sm border-4 border-cream" data-id="element-55">
          {/* Replace with your actual photo */}
          <div className="w-full h-full mix-blend-overlay opacity-40 bg-[url('https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=800&auto=format&fit=crop')] bg-cover bg-center" data-id="element-56" />
        </motion.div>

        <motion.div initial="hidden" animate="visible" variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2,
            delayChildren: 0.3
          }
        }
      }} className="flex flex-col items-center" data-id="element-57">
          <motion.h1 variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="font-playfair text-[2.75rem] leading-[1.05] sm:text-5xl md:text-7xl lg:text-8xl text-charcoal tracking-tight mb-6" data-id="element-58">
            Jacob Palkin
          </motion.h1>

          <motion.div variants={{
          hidden: {
            opacity: 0,
            scaleX: 0
          },
          visible: {
            opacity: 1,
            scaleX: 1,
            transition: {
              duration: 0.8,
              ease: 'easeOut'
            }
          }
        }} className="h-px w-24 bg-amber mb-8 origin-center" data-id="element-59" />

          <motion.h2 variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="text-sm md:text-xl text-sage font-medium tracking-wider uppercase mb-6" data-id="element-60">
            Aspiring Legal Professional
          </motion.h2>

          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.21, 0.47, 0.32, 0.98]
            }
          }
        }} className="text-base md:text-xl text-charcoal/70 max-w-2xl leading-relaxed font-light" data-id="element-61">
            Bay Area native working through the UCLA Paralegal Training Program
            and looking to break into the legal field.
          </motion.p>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-charcoal/40" data-id="element-62">
        <span className="text-xs uppercase tracking-widest font-medium" data-id="element-63">
          Scroll to read
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-64">
          <ArrowDown size={16} className="text-amber" data-id="element-65" />
        </motion.div>
      </motion.div>
    </section>;
}